module.exports = __webpack_public_path__ + "static/ic_withdrawal_success.55340e96.png";